declare const divMain : HTMLDivElement;
declare const divMap : HTMLDivElement;
declare const divFrameRate : HTMLDivElement;

let DocWidth=Math.floor(window.innerWidth);
let DocHeight=Math.floor(window.innerHeight-.5);
divMain.style.width=DocWidth+"px";
divMain.style.height=DocHeight+"px";

const MapSize={width:25,height:15};

divMap.style.width=MapSize.width*100+ "px";
divMap.style.height=MapSize.height*100+"px";

//var Tiles=new Array(MapSizeY);
for(let row=0;row<MapSize.height;row++){
  //Tiles[row]=new Array(MapSizeX);
  for(let col=0;col<MapSize.width;col++){
    let img=document.createElement('img');
    img.src=Math.random()<.05 ? "img/sand.png":Math.random()<.05 ? "img/concrete.png":"img/grass.png";
    (<any>img).style=`position:absolute;top:${row*100}px;left:${col*100}px`;
    divMap.appendChild(img);
  }
}

const Player={
  el:document.createElement('img'),
  direction:"left",
  posx:3,posy:3,
  moving:false,
  Update() {
    this.el.style.top=Player.posy*100+"px";
    this.el.style.left=Player.posx*100+"px";
    this.el.src=`img/player-${this.direction}.png`;
    divMap.style.top=Math.round(DocHeight/2-(this.posy*100)) + "px";
    divMap.style.left=Math.round(DocWidth/2-(this.posx*100)) + "px";
  }
};
Player.el.style.position="absolute";
Player.el.style.filter="drop-shadow(10px -10px 5px #00000040)";
divMap.appendChild(Player.el);
Player.Update();

document.addEventListener("keydown", e=> {
  switch (e.key) {
    case "a":
      Player.direction = "left";
      break;
    case "d":
      Player.direction = "right";
      break;
    case "w":
      Player.direction = "up";
      break;
    case "s":
      Player.direction = "down";
      break;
    default:
      return;
  }
  e.preventDefault();
  e.stopPropagation();
  Player.moving=true;
  Player.Update();
});
document.addEventListener("keyup", ()=> Player.moving=false);

let LastAni=new Date().getTime();
function WaitForNextAni() {
  window.requestAnimationFrame(()=> {
    let nowAni=new Date().getTime();
    let FPS=1000/(nowAni-LastAni);
    divFrameRate.innerText="Frame rate: "+Math.round(FPS);
    if(Player.moving) {
      const Speed=3;
      const Dist=Speed / FPS;
      switch(Player.direction){
        case "right":
          Player.posx+=Dist;
          if(Player.posx>MapSize.width-1) {Player.posx=MapSize.width-1;Player.moving=false;}
          break;
        case "left":
          Player.posx-=Dist;
          if(Player.posx<0) {Player.posx=0;Player.moving=false;}
          break;
        case "up":
          Player.posy-=Dist;
          if(Player.posy<0) {Player.posy=0;Player.moving=false;}
          break;
        case "down":
          Player.posy+=Dist;
          if(Player.posy>MapSize.height-1) {Player.posy=MapSize.height-1;Player.moving=false;}
          break;
      }
      Player.Update();
    }
    LastAni=nowAni;
    WaitForNextAni();
  });
}
WaitForNextAni();
